import { Answer } from '@shared/models/answer';
import { CandidateComment } from '@shared/models/candidate-comment';
import { CandidateContactAction } from '@shared/models/candidate-contact-action';
import { CandidateHistory } from '@shared/models/candidate-history';
import { CandidateRecentActivity } from '@shared/models/candidate-recent-activity';
import { CandidateProfileEnum } from '@shared/models/enums/candidate-profile.enum';
import { StatusCandidateEnum } from '@shared/models/enums/status-candidate.enum';
import { StatusParticipationEnum } from '@shared/models/enums/status-participation.enum';
import { Sms, toSms } from '@shared/models/sms';
import { UnavailabilitySlot } from '@wizbii/utils/models';

export enum TransferMode {
  copy = 'copy',
  move = 'move',
}

export class CandidateParticipation {
  answers: Answer[];
  author: string;
  candidateComments: CandidateComment[];
  candidateContactActions: CandidateContactAction[];
  candidateHistory: CandidateHistory[];
  candidateRecentActivities: CandidateRecentActivity[];
  dateModified: Date;
  emailSent: boolean;
  eventId: string;
  id: string;
  messageId: string;
  profile?: CandidateProfileEnum;
  profileId: string;
  resumeFileId: string;
  smsList: Sms[];
  sourceOrigin: string;
  sourcePlatform: string;
  utmCampaign: string;
  utmContent: string;
  utmMedium: string;
  utmSource: string;
  utmTerm: string;

  // Candidate Information form
  birthday: Date | null;
  client?: boolean;
  driverLicence: boolean;
  educationLevel: string;
  experienceYears: number;
  firstName: string;
  jobDomain: string;
  lastName: string;
  mail: string;
  motivations: string;
  phone: string;
  wantedJob: string;

  // Candidate Participation form
  jobsIds: string[];
  owner: string;
  statusParticipation: StatusParticipationEnum;

  // Candidate Status (blacklist)
  statusCandidate: StatusCandidateEnum;

  // Candidate Interviews form
  unavailabilitySlots?: UnavailabilitySlot[];

  constructor(data: Record<string, any>) {
    this.id = data['id'];
    this.firstName = data['firstName'];
    this.lastName = data['lastName'];
    this.eventId = data['eventId'];
    this.mail = data['mail'];
    this.phone = data['phone'];
    this.jobsIds = data['jobsIds'];
    this.statusParticipation = data['statusParticipation'] as StatusParticipationEnum;
    this.statusCandidate = data['statusCandidate'] as StatusCandidateEnum;
    this.candidateRecentActivities = (data['activities'] || []).map(
      (activity) => new CandidateRecentActivity(activity)
    );
    this.candidateHistory = (data['history'] || []).map((historyLine: any) => new CandidateHistory(historyLine));
    this.candidateComments = (data['comments'] || []).map((comment: any) => new CandidateComment(comment));
    this.candidateContactActions = (data['contactActions'] || []).map((action) => new CandidateContactAction(action));
    this.profileId = data['profileId'];
    this.sourcePlatform = data['sourcePlatform'];
    this.sourceOrigin = data['sourceOrigin'];
    this.resumeFileId = data['resumeFileId'];
    this.author = data['author'];
    this.messageId = data['messageId'];
    this.owner = data['owner'];
    this.emailSent = data['emailSent'];
    this.dateModified = data['dateModified'] ? new Date(data['dateModified']) : new Date();
    this.birthday = data['birthday'] ? new Date(data['birthday']) : null;
    this.answers = data['answers'] || [];
    this.utmSource = data['utmSource'];
    this.utmMedium = data['utmMedium'];
    this.utmCampaign = data['utmCampaign'];
    this.utmTerm = data['utmTerm'];
    this.utmContent = data['utmContent'];
    this.smsList = (data['smsList'] || []).map(toSms);
    this.wantedJob = data['wantedJob'];
    this.jobDomain = data['jobDomain'];
    this.experienceYears = data['experienceYears'];
    this.motivations = data['motivations'];
    this.educationLevel = data['educationLevel'];
    this.driverLicence = data['driverLicence'];
    this.profile = data['profile'];
    this.client = data['client'];
    this.unavailabilitySlots = data['unavailabilitySlots'];
  }
}
